import 'css-chunksrc/client/common/layout/projectHistory/search/styles.scss';export default {
  "search": "_search_hyz2i_1"
};